import React from 'react';
import { ClientShop } from '../clientContracts/clientShops/entities';
import { useClientShops } from '../hooks/useClientShops';

interface ClientShopsContextProps {
    children: React.ReactNode;
}

export const ClientShopsContext = React.createContext<{
    clientShops: ClientShop[];
    selectedClientShop?: ClientShop;
    setSelectedClientShop: React.Dispatch<React.SetStateAction<ClientShop | undefined>>;
    getClientShops: () => Promise<void>;
    loading: boolean;
}>({
    clientShops: [],
    getClientShops: async () => {
        // Do nothing
    },
    loading: false,
    selectedClientShop: undefined,
    setSelectedClientShop: () => {
        // Do nothing
    },
});

export const ClientShopsProvider = ({ children }: ClientShopsContextProps) => {
    const { clientShops, loading, getClientShops, selectedClientShop, setSelectedClientShop } =
        useClientShops({ includeNonAuthed: true });

    return (
        <ClientShopsContext.Provider
            value={{
                clientShops,
                getClientShops,
                selectedClientShop,
                setSelectedClientShop,
                loading,
            }}
        >
            {children}
        </ClientShopsContext.Provider>
    );
};
